import Game from './components/Game.vue';
import Home from './components/Home.vue';
import { i18n } from "./i18n.js";
import { store } from "./store/store.js";

export const routes = [

  {
    path: '/play', name: "play", components: { content: Game },
    beforeEnter(to, from, next) {
      if (store.getters.players.length === 0) return next("/")

      return next()
    }
  },
  { path: '', name: "home", components: { content: Home } },
  { path: '/:lang',
    beforeEnter(to,from, next) {
      const lang = to.params.lang;
      if (["cz", "en"].includes(lang)) {
        if (i18n.locale !== lang) {
          store.dispatch("setLanguage", lang);
          i18n.locale = lang;
        }
      }
      return next();
    },
    components: { content: Home }
  }

];



// WEBPACK FOOTER //
// ./src/routes.js